import {
  Button,
  ButtonProps,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  cardHeaderClasses,
  styled,
  Typography,
  useTheme,
} from '@mui/material';
import * as React from 'react';

export type DataImportItemProps = {
  title: React.ReactNode;
  subTitle?: React.ReactNode;
  icon?: React.ReactNode;
  onClick: () => void;
  description: string;
  actionButtonText: string;
  actionButtonVariant?: ButtonProps['variant'];
  actionButtonTestId?: string;
};

const CardHeaderInlined = styled(CardHeader)(({ theme }) => ({
  paddingBottom: theme.spacing(),
  [`.${cardHeaderClasses.content}`]: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  ':hover': {
    border: 'solid',
    borderWidth: '1px',
    borderColor: theme.palette.custom.neutral.neutral70,
  },
}));

export const DataImportItem = ({
  title,
  subTitle,
  icon,
  onClick,
  description,
  actionButtonText,
  actionButtonVariant,
  actionButtonTestId,
}: DataImportItemProps) => {
  const theme = useTheme();
  return (
    <StyledCard variant="outlined">
      <CardHeaderInlined
        avatar={icon}
        title={title}
        subheader={subTitle}
        slotProps={{
          title: {
            variant: 'h6',
          },
        }}
      />
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography gutterBottom variant="body2">
          {description}
        </Typography>
      </CardContent>
      <CardActions sx={{ m: theme.spacing(), justifyContent: 'end' }}>
        <Button
          size="small"
          variant={actionButtonVariant ?? 'contained'}
          onClick={onClick}
          color="primary"
          data-testid={actionButtonTestId}
        >
          {actionButtonText}
        </Button>
      </CardActions>
    </StyledCard>
  );
};
